import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

export type DashLevel = 'urgent' | 'today' | 'week';
export type DashTone = 'up' | 'down' | 'flat';

export interface DashAction { key: string; level: DashLevel; count: number; title: string; detail: string; module: string; cta: string; route: string; }
export interface DashKpi { key: string; label: string; value: number; text: string; tone: DashTone; }
export interface DashHealth {
  place: string; name: string; status: 'Bien' | 'Vigilar' | 'Atender';
  surgeries?: number; drafts?: number; red?: number; amber?: number; green?: number; incidents?: number; transfers?: number;
}
export interface DashMonthPlace { place: string | null; name: string; folio: number; remission: number; }
export interface DashMonth { month: number; label: string; future: boolean; folio: number; remission: number; byPlace: DashMonthPlace[]; }
export type DashProfile = 'direccion' | 'mesa' | 'coordinacion' | 'tecnico';
export type DashFormat = 'int' | 'money' | 'days';
export interface DashExecKpi { key: string; label: string; value: number; format: DashFormat; hint: string; tone: DashTone; route: string | null; }
export interface DashChart {
  key: string; title: string; type: 'bar' | 'line' | 'hbar' | 'donut';
  labels: string[]; series: { name: string; values: number[] }[];
  subtitle: string; format: DashFormat; route: string | null;
}
export interface DashExecutive {
  profile: DashProfile; profileLabel: string; canSwitch: boolean;
  profiles: { key: DashProfile; label: string }[];
  kpis: DashExecKpi[]; charts: DashChart[];
}
export interface DashSummary {
  executive?: DashExecutive;
  generatedAt: string;
  shift: string;
  modules: Record<'folios' | 'inventory' | 'incidents' | 'requests' | 'transfers' | 'custody', boolean>;
  scoped: boolean;
  places: { id: string; name: string }[];
  actions: DashAction[];
  kpis: DashKpi[];
  health: DashHealth[];
  chart: { year: number; currentMonth: number; months: DashMonth[] } | null;
  feed: { when: string; text: string; tone: 'ok' | 'info' | 'warn' | 'danger' }[];
}

/**
 * Tablero de Inicio. El API recorta TODO por el rol (módulos) y el alcance
 * (hospitales / especialidades) del usuario; aquí solo se pinta lo que llega.
 */
@Injectable({ providedIn: 'root' })
export class DashboardSummaryService extends ApiBaseService<DashSummary> {
  constructor() { super('dashboard'); }

  /** `view` solo lo respeta el API para Dirección (ver el tablero de otro perfil). */
  async summary(year: number, place?: string | null, view?: string | null): Promise<DashSummary | null> {
    const q = new URLSearchParams({ year: String(year) });
    if (place) q.set('place', place);
    if (view) q.set('view', view);
    const r: any = await this.request<DashSummary>(`dashboard/summary?${q.toString()}`, 'GET');
    return (r?.data?.[0] as DashSummary) ?? null;
  }
}
